<script setup>
   const { t } = useI18n({ useScope: 'local' });
   const route = useRoute();

const { $get } = useAxios();
const { locale } = useI18n();

const { data: news } = await useAsyncData(
  `get news by id - ${route.params.id}-${locale}`,
  () => $get(`/news/${route.params.id}`),
  { lazy: true, default: () => {} }
);

</script>
<template>
  <NuxtLayout name="default">
    <section class="container mt-6 px-4 lg:px-0 mb-24 md:mb-0"> 
        <div v-if="news" class="grid gap-5"> 
        <nuxt-link class="text-3xl lg:text-4xl">{{ news.title }}</nuxt-link>
    <p class="text-base md:text-lg lg:text-xl" v-html="news.content"></p>

  </div>
</section>
  </NuxtLayout>
</template>


